import {
	StyledShareControlContainer,
	StyledShareReturnButton,
} from 'components/Selfiebooth/ShareDisplay/styled'
import { FiX } from 'react-icons/fi'
import React from 'react'

interface ControlsProps {
	source: 'consent'|'share';
	onCancel: () => void;
}

const Controls = ({ source, onCancel }: ControlsProps) => {

	return <>
		<StyledShareControlContainer>
			{source === "consent" && <>
				<StyledShareReturnButton onClick={onCancel}>
          <FiX />
				</StyledShareReturnButton>
			</>}
			{source === "share" && <>
        <StyledShareReturnButton onClick={onCancel}>
          <FiX />
        </StyledShareReturnButton>
			</>}
		</StyledShareControlContainer>
	</>;
}

export default Controls;